// src/pages/Calculator.jsx
import React from 'react';
import PositionCalc from '../components/PositionCalc';

export default function Calculator({ settings , lang = 'en'}) {
  return (
    <div className="fade-in" style={{ padding: '28px 32px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, color: '#f0f0f5', margin: 0 }}>Position Size Calculator</h1>
        <p style={{ color: '#55556a', fontSize: 12, margin: '3px 0 0', fontFamily: "'DM Mono', monospace" }}>
          Calculate exact lot size for any pair based on your risk
        </p>
      </div>
      <div style={{ background: '#16161f', border: '1px solid #1e1e2e', borderRadius: 12, padding: 24 }}>
        <PositionCalc settings={settings} />
      </div>
    </div>
  );
}
